import MojitoCore from 'mojito/core';

import {resolveBackground} from '#core/utils/color-utils.js';

import {generateBetFundsInfo, BET_FUNDS_INFO_TYPES} from '#core/application/modules/tiles/bet-funds-info/index.js';
import {generateInput} from '#core/application/modules/tiles/input/index.js';
import {generatePrimaryButton, generateTertiaryButton} from '#core/application/modules/tiles/button/index.js';
import {generateRangeInput} from '#core/application/modules/tiles/range-input/index.js';
import {generateBorder} from '#core/application/modules/tiles/border/index.js';

const merge = MojitoCore.Presentation.uiStyle.merge;

export function autoCashoutDialogConfig(PALETTE) {
    const AC_BET_FUNDS_INFO = generateBetFundsInfo(PALETTE.AC_BET_FUNDS_INFO, BET_FUNDS_INFO_TYPES.MEDIUM);
    const AC_TEXT_INPUT = merge(generateInput(PALETTE.AC_INPUT), {
        style: {
            base: {
                minHeight: '40px',
                minWidth: '104px',
            },
        },
    });
    const AC_RANGE_INPUT = generateRangeInput(PALETTE.AC_RANGE_INPUT, {POINTER_EVENTS: 'none'});

    return {
        AutoCashoutRuleView: {
            formContainer: {
                style: {
                    ...resolveBackground(PALETTE.AC_DIALOG_CONTAINER_BG),
                    borderRadius: PALETTE.AC_DIALOG_CONTAINER_BORDER_RADIUS,
                    fontWeight: 400,
                },
            },
            header: {
                style: {
                    textAlign: 'center',
                    ...PALETTE.AC_DIALOG_TITLE_TEXT,
                },
            },
            rangeMinMaxContainer: {
                style: {
                    padding: '8px 0 16px',
                    borderColor: PALETTE.AC_SEPARATOR_COLOR,
                    borderWidth: '0 0 1px',
                    borderStyle: 'solid',
                },
            },
            betInfoLabel: {
                style: {
                    ...PALETTE.AC_BET_TITLE_TEXT,
                },
            },
            betDateLabel: {
                style: {
                    ...PALETTE.AC_BET_DATE_TEXT,
                },
            },
            currentCashoutLabel: AC_BET_FUNDS_INFO.label,
            currentCashoutValue: AC_BET_FUNDS_INFO.value,
            totalStakeLabel: AC_BET_FUNDS_INFO.label,
            totalStakeValue: AC_BET_FUNDS_INFO.value,
            potentialReturnsLabel: AC_BET_FUNDS_INFO.label,
            potentialReturnsValue: AC_BET_FUNDS_INFO.value,
            potentialReturnsContainer: {
                style: {
                    borderColor: PALETTE.AC_SEPARATOR_COLOR,
                },
            },
            style: {
                statusText: {
                    base: {
                        textAlign: 'center',
                        ...PALETTE.AC_STATUS_TEXT,
                    },
                    info: {
                        borderStyle: 'none',
                    },
                    warning: {
                        ...resolveBackground(PALETTE.AC_WARNING_NOTIFICATION.WARNING_BG),
                        ...generateBorder(PALETTE.AC_WARNING_NOTIFICATION.WARNING_BORDER),
                        textAlign: 'left',
                        ...PALETTE.AC_WARNING_NOTIFICATION.WARNING_TEXT,
                    },
                    error: {
                        ...resolveBackground(PALETTE.AC_ERROR_NOTIFICATION.ERROR_BG),
                        ...generateBorder(PALETTE.AC_ERROR_NOTIFICATION.ERROR_BORDER),
                        textAlign: 'left',
                        ...PALETTE.AC_ERROR_NOTIFICATION.ERROR_TEXT,
                    },
                },
            },
            autoCashoutLabel: {
                style: {
                    ...PALETTE.AC_INPUT_LABEL_TEXT,
                },
            },
            autoCashoutTextInput: AC_TEXT_INPUT,
            autoCashoutCustomTextInput: AC_TEXT_INPUT,
            createRuleButton: generatePrimaryButton(PALETTE.AC_CREATE_RULE_BUTTON),
            cancelButton: generateTertiaryButton(PALETTE.AC_CANCEL_BUTTON),
            closeButton: generatePrimaryButton(PALETTE.AC_CLOSE_BUTTON),
            removeRuleButton: generateTertiaryButton(PALETTE.AC_REMOVE_RULE_BUTTON),
            autoCashoutRange: AC_RANGE_INPUT.component,
            ...AC_RANGE_INPUT.labels,
            // active cashout
            activeRuleIcon: {
                src: 'system-cashout',
                style: {
                    fill: PALETTE.AC_ACTIVE_RULE_ICON_COLOR,
                    minWidth: '16px',
                    minHeight: '16px',
                },
            },
            activeRuleText: {
                style: {
                    ...PALETTE.AC_ACTIVE_RULE_LABEL_TEXT,
                },
            },
            activeRuleCashoutText: {
                style: {
                    ...PALETTE.AC_ACTIVE_RULE_CASHOUT_LABEL_TEXT,
                },
            },
            activeRuleAmount: {
                style: {
                    ...PALETTE.AC_ACTIVE_RULE_CASHOUT_AMOUNT_LABEL_TEXT,
                },
            },
            // pending cashout
            waitingMessage: {
                style: {
                    textAlign: 'center',
                    ...PALETTE.AC_PENDING_MESSAGE_LABEL_TEXT,
                },
            },
            spinner: {
                image: {
                    style: {
                        fill: PALETTE.AC_PENDING_SPINNER_ICON_COLOR,
                        minWidth: '32px',
                        minHeight: '32px',
                    },
                },
                style: {
                    container: {
                        flexBasis: '32px',
                        height: '32px',
                    },
                },
            },
        },
    };
}
